import { render } from "./AboutUs.vue?vue&type=template&id=5ae9bd53&scoped=true"
const script = {}

import "./AboutUs.vue?vue&type=style&index=0&id=5ae9bd53&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae9bd53"]])

export default __exports__